module.exports = __webpack_public_path__ + "static/media/tacometro-alto-p.39847c48.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/contentassets/tacometro-alto-p.svg
// module id = 154
// module chunks = 0